import { useAuth } from "@/hooks/useAuth";
import { useAdminEdit } from "@/contexts/AdminEditContext";
import { Pencil, PencilOff } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const AdminEditToggle = () => {
  const { isAdmin } = useAuth();
  const { editMode, toggleEditMode } = useAdminEdit();

  if (!isAdmin) return null;

  return (
    <AnimatePresence>
      <motion.button
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0, opacity: 0 }}
        onClick={toggleEditMode}
        className={`fixed bottom-20 md:bottom-6 left-4 z-[60] w-12 h-12 rounded-full flex items-center justify-center shadow-xl border transition-all duration-300 ${
          editMode
            ? "bg-primary text-primary-foreground border-primary/50 shadow-[0_0_20px_hsl(var(--primary)/0.4)]"
            : "bg-card text-muted-foreground border-border hover:border-primary/40 hover:text-primary"
        }`}
        title={editMode ? "סיום עריכה" : "מצב עריכה"}
        whileTap={{ scale: 0.9 }}
      >
        {editMode ? <PencilOff size={20} /> : <Pencil size={20} />}
      </motion.button>
      {editMode && (
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0 }}
          className="fixed bottom-[86px] md:bottom-[68px] left-4 z-[60] bg-primary text-primary-foreground text-xs font-bold px-3 py-1.5 rounded-lg shadow-lg whitespace-nowrap"
        >
          ✏️ מצב עריכה פעיל
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AdminEditToggle;
